import React, { Component } from 'react';
import { Spacer } from '../../components';
import s from './HostStyles.module.scss';

export default class SpacerHost extends Component {
    constructor(props) {
        super(props);
        this.state = { foo: 'Foo' };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <Spacer foo={this.state.foo} />
            </div>
        );
    }
}
